import React from 'react'

import { Container } from './styles'

export interface OptionProps<T extends string | number | undefined> {
  id?: string
  value: T
  active?: boolean
  selected?: boolean
  tabIndex: number
  children: React.ReactNode
}

const OptionInner = <T extends string | number | undefined>(
  { value, active, selected, tabIndex, children, ...rest }: OptionProps<T>,
  ref: React.ForwardedRef<HTMLLIElement>,
) => {
  return (
    <Container
      ref={ref}
      role="option"
      tabIndex={tabIndex}
      aria-selected={active}
      data-value={value}
      active={active}
      selected={selected}
      data-active={active}
      data-selected={selected}
      {...rest}
    >
      {children}
    </Container>
  )
}

export const Option = React.forwardRef(OptionInner) as <
  T extends string | number | undefined,
>(
  props: OptionProps<T> & { ref?: React.ForwardedRef<HTMLLIElement> },
) => ReturnType<typeof OptionInner>
